import { AppNS } from 'app';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getAvailability as getAvailabilityApiCall } from '../../api/dcra-inspections/inspectors';
import { AppThunk } from '../index';

export interface ConstructionAvailabilityState {
  availabilityData: AppNS.InspectorAvailability;
  isConstructionAvailabilityLoading: boolean;
  availabilityLoadingError: string;
  isConstructionAvailabilityRequested: boolean;
  isConstructionAvailabilitySuccess: boolean;
}

const initialState: ConstructionAvailabilityState = {
  availabilityData: {},
  availabilityLoadingError: '',
  isConstructionAvailabilityLoading: false,
  isConstructionAvailabilityRequested: false,
  isConstructionAvailabilitySuccess: false,
};

const constructionAvailabilitySlice = createSlice({
  name: 'constructionAvailability',
  initialState,
  reducers: {
    constructionAvailabilityStart(state: ConstructionAvailabilityState) {
      state.isConstructionAvailabilityRequested = false;
      state.isConstructionAvailabilityLoading = true;
      state.isConstructionAvailabilitySuccess = false;
    },
    constructionAvailabilitySuccess(
      state: ConstructionAvailabilityState,
      action: PayloadAction<AppNS.InspectorAvailability>
    ) {
      state.availabilityData = action.payload;
      state.isConstructionAvailabilityRequested = true;
      state.isConstructionAvailabilityLoading = false;
      state.isConstructionAvailabilitySuccess = true;
    },
    constructionAvailabilityFailed(
      state: ConstructionAvailabilityState,
      action: PayloadAction<string>
    ) {
      state.isConstructionAvailabilityRequested = true;
      state.isConstructionAvailabilityLoading = false;
      state.isConstructionAvailabilitySuccess = false;
      state.availabilityLoadingError = action.payload;
    },
  },
});

export const {
  constructionAvailabilityStart,
  constructionAvailabilitySuccess,
  constructionAvailabilityFailed,
} = constructionAvailabilitySlice.actions;

export default constructionAvailabilitySlice.reducer;

export const getAvailability =
  (params: AppNS.Params): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(constructionAvailabilityStart());
      const data = await getAvailabilityApiCall(params);

      dispatch(constructionAvailabilitySuccess(data));
    } catch (message) {
      if (message) {
        dispatch(constructionAvailabilityFailed(message as string));
      }
    }
  };
